var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15V11M10 6.99999H10.01M1 6.94144V15.0585C1 15.4012 1 15.5725 1.05048 15.7253C1.09515 15.8605 1.16816 15.9846 1.26463 16.0893C1.37369 16.2076 1.52345 16.2908 1.82297 16.4572L9.22297 20.5683C9.50658 20.7259 9.64838 20.8046 9.79855 20.8355C9.93146 20.8629 10.0685 20.8629 10.2015 20.8355C10.3516 20.8046 10.4934 20.7259 10.777 20.5683L18.177 16.4572C18.4766 16.2908 18.6263 16.2076 18.7354 16.0893C18.8318 15.9846 18.9049 15.8605 18.9495 15.7253C19 15.5725 19 15.4012 19 15.0585V6.94144C19 6.5988 19 6.42747 18.9495 6.27467C18.9049 6.1395 18.8318 6.01542 18.7354 5.91073C18.6263 5.79239 18.4766 5.70919 18.177 5.54279L10.777 1.43168C10.4934 1.27412 10.3516 1.19534 10.2015 1.16445C10.0685 1.13712 9.93146 1.13712 9.79855 1.16445C9.64838 1.19534 9.50658 1.27412 9.22297 1.43167L1.82297 5.54279C1.52345 5.70919 1.37369 5.79239 1.26463 5.91073C1.16816 6.01542 1.09515 6.1395 1.05048 6.27467C1 6.42747 1 6.59879 1 6.94144Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.9b91f4eac80b4ed198909d0e821932a1.svg";
export { ForwardRef as ReactComponent };